import React, { useContext } from "react";

import LocaleContext from "@/i18n";

import { Col1, Col2, Col3, FlexGrid, Text } from "./styles";

export type MeterFooterProps = {
  participants?: number;
};

const MeterFooter: React.FC<MeterFooterProps> = (
  props: MeterFooterProps
): React.JSX.Element => {
  const localeContext = useContext(LocaleContext);
  const participants = props.participants?.toLocaleString();

  return (
    <FlexGrid data-qa="footer">
      <Col1>
        {participants && (
          <Text>
            <span>{participants}</span>
            {" " + localeContext.translation.participants}
          </Text>
        )}
      </Col1>
      <Col2 />
      <Col3 />
    </FlexGrid>
  );
};

export default MeterFooter;
